module.exports = __webpack_public_path__ + "static/media/bureau_1.23214f1b.png";